import O1HD from "../../../engines/gameEngine";
import PageBase from "../../../engines/modules/uiModule/PageBase";
import { IPagePramsBase } from "../../../engines/modules/uiModule/UIPrams";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ShowPicturePage extends PageBase {
    @property({ type: cc.Sprite, displayName: "图片显示节点" })
    img_sprite: cc.Sprite = null;
    @property({ type: cc.Node, displayName: "黑布" })
    node_mask: cc.Node = null;
    async OnPageOpen(prams?: IPagePramsBase): Promise<void> {
    }
    init(spriteNode: cc.Sprite) {
        this.img_sprite.spriteFrame = spriteNode.spriteFrame;

        let size = spriteNode.spriteFrame.getOriginalSize();

        let bili = size.height / size.width;
        this.img_sprite.node.width = O1HD.Canvas().getContentSize().width;
        this.img_sprite.node.height = O1HD.Canvas().getContentSize().width * bili


        this.img_sprite.node.scale = spriteNode.spriteFrame.getOriginalSize().width / O1HD.Canvas().getContentSize().width;
        let spritePos = cc.v2((0.5-spriteNode.node.anchorX)*size.width,(0.5-spriteNode.node.anchorY)*size.height)
        let pos = this.node.parent.convertToNodeSpaceAR(spriteNode.node.convertToWorldSpaceAR(spritePos));
        this.img_sprite.node.setPosition(pos);
        this.node_mask.active = false
        cc.tween(this.img_sprite.node)
            .to(0.15, { scale: 1, position: cc.v3(0, 0) })
            .call(()=>{

                this.node_mask.active = true;
            })
            .start()
    }

    onClickClose() {
        this.ClosePage();
    }
}